<nz-row nzJustify="space-between" nzAlign="middle">
  <nz-col style="margin-bottom: 10px;">
    <!--  [(ngModel)]="searchText" (ngModelChange)="onSearch()" -->
    <input nz-input placeholder="Search..."  [(ngModel)]="searchText" (ngModelChange)="onSearch()" />
  </nz-col>
  <nz-col>
    <button nz-button nzType="primary" (click)="onAdd()">Add</button>
    <!--  (click)="onAdd()" -->
  </nz-col>
</nz-row>


<nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
  <nz-table [nzData]="paymentList" [nzBordered]="true" [nzSize]="'middle'" [nzShowPagination]="false">
    <thead>
      <tr>
        <th>Payment ID</th>
        <th>Vendor</th>
        <!-- <th>Category</th> -->
        <th>Amount</th>
        <th>Payment Mode</th>
        <th>Paid On</th>
        <th>Status</th>
        <th>Reference</th>
        <th>Files</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let payment of paymentList">
        <td (click)="onDetailsOpen(payment.id)" style="font-weight: 600;"> <a href="javascript:void(0)">
        <nz-tag [nzColor]="'geekblue'">    {{ payment.transaction_id | uppercase }} </nz-tag> </a></td>
        <td> <a href="javascript:void(0)" (click)="onVendorDetails(payment?.invoice_details?.vendor_details?.id)"> {{ payment?.invoice_details?.vendor_details?.name | titlecase }}</a> </td>
        <!-- <td>
          <nz-tag [nzColor]="'purple'"
            *ngFor="let category of payment?.invoice_details?.vendor_details.categories_serviced" [nzBordered]="false">
            {{category}}
          </nz-tag>
        </td> -->
        <td>{{ payment.amount_paid | currency }}</td>
        <td>{{ payment.payment_method }}</td>
        <td>{{ payment.payment_date | date: 'mediumDate' }}</td>
        <td>
          <nz-tag [nzColor]="
              payment.status === 'Completed'
                ? 'green'
                : payment.status === 'Pending'
                ? 'orange'
                : 'red'
            ">
            {{ payment.status }}
          </nz-tag>
        </td>
        <td>{{ payment.notes }}</td>
        <td>
          <span *ngFor="let file of payment?.file_details; let i = index">
            <a [href]="getFileDownloadLink(file.file_url)" download target="_blank">{{getFileName(file.file_url)}}</a> <span
              *ngIf="i < payment?.file_details.length - 1">, </span>
          </span>
        </td>
        <td>
          <button nz-button nzType="default" nzSize="small"><nz-icon nzType="edit" nzTheme="outline" (click)="editPayment(payment)" />
          </button>
          <button nz-button nzType="default" nzDanger style="margin-left: 10px;" nzSize="small" nz-popconfirm   nzPopconfirmTitle="Are you sure delete this payment?"
          nzPopconfirmPlacement="bottom" (nzOnConfirm)="deletePayment(payment.id)"
            class="custom-popconfirm"

            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
            [nzPopconfirmTitle]="popconfirmTpl"
           >
            <nz-icon nzType="delete"  nzTheme="outline" />
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-spin>

<ng-template #popconfirmTpl let-popconfirm="popconfirm">
    <div class="custom-popconfirm-header">
      <span class="custom-popconfirm-title">
          Confirm Deletion
      </span>
    </div>
    <div class="custom-popconfirm-icon-area">
        <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
            <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
        </span>
    </div>
    <div class="custom-popconfirm-message description">
        Are you sure you want to delete this item?<br />
        <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
    </div>
</ng-template>
